import React from 'react';
import Button from '../common/Button';

const ConfirmationDialog = ({ open, onClose, onConfirm, title, message }) => {
    if (!open) return null;
    return (
        <div className="dialog-overlay">
            <div className="dialog">
                <h3>{title || 'Confirm'}</h3>
                <p>{message || 'Are you sure?'}</p>
                <div className="dialog-actions">
                    <Button variant="secondary" onClick={onClose}>Cancel</Button>
                    <Button variant="danger" onClick={onConfirm}>Confirm</Button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationDialog;
